export const ROUTE_ROOT = { key: 'root', path: '/', noAuth: true }
export const ROUTE_LOGIN = { key: 'login', path: '/login', noAuth: true }
export const ROUTE_FORGOT_PASSWORD = { key: 'forgot-password', path: '/forgot-password', noAuth: true }
export const ROUTE_RESET_PASSWORD = { key: 'reset-password', path: '/reset-password', noAuth: true }
export const ROUTE_SIGN_UP = { key: 'sign-up', path: '/sign-up', noAuth: true }
export const ROUTE_DASHBOARD = { key: 'dashboard', path: '/dashboard' }
export const ROUTE_DECLINED = { key: 'declined', path: '/declined' }

export * from './api'